import { SalonSelect } from './SalonSelect';
import StepIndicator from '../StepIndicator';
import WaitingTimeDetails from './WaitingTimeDetails';
import { Heading, InfoButton, Para, Stack } from 'ui-components';
import { useCheckoutStore } from '../checkoutStore';
import { BookingCheckoutProps } from '../BookingCheckout';

type Props = {
  storeSlug?: BookingCheckoutProps['storeSlug'];
};

export function Step1({ storeSlug }: Props): React.ReactElement {
  const selectedStore = useCheckoutStore((state) => state.selectedStore);

  return (
    <>
      <StepIndicator index={1}>Salon {!storeSlug && ' wählen'}</StepIndicator>

      {storeSlug ? (
        <Heading variant="h4" className="font-ramillas text-start">
          DRYCUT {selectedStore?.name}
        </Heading>
      ) : (
        <SalonSelect />
      )}

      {selectedStore && <WaitingTimeDetails store={selectedStore} />}

      <Stack gap={2} direction="row">
        <Para size="xs">
          Um ein gutes Resultat zu garantiere, bitte beachte unsere "clean hair policy".
        </Para>

        <InfoButton
          title="Clean hair policy"
          text="Haare sollten keine oder wenig Produkte (Gel, Pomade, etc.) enthalten und in den vergangenen 24 Stunden gewaschen worden sein."
          className="z-20"
        />
      </Stack>
    </>
  );
}
